import axios from "axios";

const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname);

const api = axios.create({
  baseURL: isLocalDev ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api",
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : "")).filter(Boolean).join(" ");
  return e?.message || "Something went wrong. Please try again.";
}

export default api;
